<os-loading-bar />
<router-outlet />
<os-toast-host />
<os-confirm-host />
<os-consent-banner />

<!-- https://designmd.me/s/obrasync-app-br-e0ji8 -->
